export default "/images/vendor/geoportal-extensions-openlayers/src/OpenLayers/CSS/Controls/Route/GProuteCheck.png?ad86be89f18616746f7f68b4395621b6";